// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5c94ac95","455":"0f14ec6a"}[chunkId] + ".chunk.js";
};